// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/campaign/move-to-campaign.less
// module id = 737
// module chunks = 0